/* -----------------------------------------------------------------------------
 * field validators and the date field's value mapping
 * -------------------------------------------------------------------------- */

export const validateRequired = (errorMessage?: string) => (value: string) =>
  value ? null : errorMessage || `Please enter details`

const dateRegexp = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/
export const validateDateErrorMessage = 'Please use the format MM-DD-YYYY'
export const validateDate = (errorMessage?: string) => (value: string) =>
  dateRegexp.test(value) ? null : errorMessage || validateDateErrorMessage

const timeRegexp = /^([01][0-9]|2[0-3]):[0-5][0-9]$/
export const validateTimeErrorMessage = 'Please use the format HH:MM'
export const validateTime = (errorMessage?: string) => (value: string) =>
  timeRegexp.test(value) ? null : errorMessage || validateTimeErrorMessage

const emailRegexp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
export const validateEmailErrorMessage = 'Please enter a valid email address'
export const validateEmail = (errorMessage?: string) => (value: string) =>
  emailRegexp.test(value) ? null : errorMessage || validateEmailErrorMessage

const phoneRegexp = /^\d{3}-\d{3}-\d{4}$/
export const validatePhoneErrorMessage = 'Please enter a valid phone number'
export const validatePhone = (errorMessage?: string) => (value: string) =>
  phoneRegexp.test(value) ? null : errorMessage || validatePhoneErrorMessage

// MM-DD-YYYY in the input, YYYY-MM-DD in the form values
export const parseDateInput = (text: string) =>
  text.length >= 10 ? `${text.substring(6, 10)}-${text.substring(0, 5)}` : text

export const formatDateInput = (text: string) =>
  text.length >= 10 ? `${text.substring(5, 10)}-${text.substring(0, 4)}` : text
